/* eslint-disable */
/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import moment from 'moment';

// Components
import PrintableEnrollment from '../../../../../common/views/PrintableEnrollment';

function ExportEnrollment() {
  const [enrollment, setEnrollment] = useState({ });
  const { enrollments } = useSelector(store => store.enrollments);

  // Two scenarios to address. Stateful to ensure the print page has no undefined values
  // 1. An admin printing their own enrollments (/profile)
  // 2. An admin printing other agent's enrollments (/admin)
  const [agent, setAgent] = useState({ });
  const { agents = {}, user = {} } = useSelector(store => store);
  const { selectedAgent } = agents;
  useEffect(() => {
    if (!selectedAgent) {
      setAgent(user);
    } else {
      setAgent(selectedAgent);
    }
  }, []);
  
  const { quoteID } = useParams();

  // passed down to the child common/views/PrintableEnrollment that loads in network content
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (loaded) {
      window.print();
    }
  }, [loaded]);

  useEffect(() => {
    const selectedEnrollment = enrollments.filter(e => e.quote_id === quoteID)[0];
    if (selectedEnrollment) {
      setEnrollment(selectedEnrollment);
    }
  }, []);

  function caps(string = '') {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Setting filename
  useEffect(() => {
    if (enrollment && Object.keys(enrollment).length) {
      const { confirmation_number, submit_date, fields = {} } = enrollment;
      const { first_name, last_name, plan = {} } = fields;
      const { PlanName } = plan;
      const fullName = `${caps(first_name)} ${caps(last_name)}`;
      const fileName = `Enrollment #${confirmation_number} in ${PlanName} for ${fullName} submitted at ${moment(submit_date).format('YYYY-MM-DD')}`;
      document.title = fileName;
    }
  }, [enrollment]);

  return (
    <div
      className={[
        'bg-white',
        'd-flex justify-content-center',
      ].join(' ')}
      style={{
        // Ensure reactstrap styling doesn\'t interfere w/ bg-white
        minWidth: '100vw',
        minHeight: '100vh',
      }}
    >
      <PrintableEnrollment enrollment={enrollment} agent={agent} setLoaded={setLoaded} />
    </div>
  );
}
export default ExportEnrollment;
